module.exports = __webpack_public_path__ + "static/media/intro-image.6ed59030.jpg";